// extracted by mini-css-extract-plugin
export var cardHeader = "_sp-0";
export var reorderHandle = "_sp-3";
export var titleArea = "_sp-1";
export var titleAreaWithHandle = "_sp-2";